import api from '@/api';

const sortFunction = (a, b) => {
    if (!a) {
        return 1;
    } else {
        return a.localeCompare(b, {
            sensitivity: 'base',
            ignorePunctuation: true,
            numeric: true,
        });
    }
};

const cleanOption = (car, key) => {
    // Don't want null, undefined, or empty strings in our filter options
    if (!car[key] || car[key] === undefined) return;
    return car[key];
};

export const state = {
    all: [],
};

export const getters = {
    new: state => state.all.filter(car => car.type === 'N'),
    used: state => state.all.filter(car => car.type === 'U'),
    cpo: state => state.all.filter(car => car.cpo),
    type: (state, getters) => {
        const types = [];
        if (getters.new.length) types.push('New');
        if (getters.used.length) types.push('Used');
        if (getters.cpo.length) types.push('Certified');
        return types;
    },
    year: state => {
        const distinct = [
            ...new Set(state.all.map(car => cleanOption(car, 'year'))),
        ];
        return distinct.sort();
    },
    make: state => {
        const distinct = [
            ...new Set(state.all.map(car => cleanOption(car, 'make'))),
        ];
        return distinct.sort(sortFunction);
    },
    model: state => {
        const distinct = [
            ...new Set(state.all.map(car => cleanOption(car, 'model'))),
        ];
        return distinct.sort(sortFunction);
    },
    trim: state => {
        const distinct = [
            ...new Set(state.all.map(car => cleanOption(car, 'trim'))),
        ];
        return distinct.sort(sortFunction);
    },
    body: state => {
        const distinct = [
            ...new Set(state.all.map(car => cleanOption(car, 'body'))),
        ];
        return distinct.sort(sortFunction);
    },
    drive: state => {
        const distinct = [
            ...new Set(state.all.map(car => cleanOption(car, 'drive'))),
        ];
        return distinct.sort(sortFunction);
    },
    transmission: state => {
        const distinct = [
            ...new Set(state.all.map(car => cleanOption(car, 'transmission'))),
        ];
        return distinct.sort(sortFunction);
    },
    colorExt: state => {
        const distinct = [
            ...new Set(state.all.map(car => cleanOption(car, 'colorExt'))),
        ];
        return distinct.sort(sortFunction);
    },
    engine: state => {
        const distinct = [
            ...new Set(state.all.map(car => cleanOption(car, 'engine'))),
        ];
        return distinct.sort(sortFunction);
    },
    priceHigh: state => {
        return state.all.reduce((highValue, car) => {
            // normalize the price to check
            let price = car.finalPrice > 0 ? car.finalPrice : car.msrp;
            if (price < 0) price = 0;
            // check if current price is higher
            if (price > highValue) highValue = price;
            return highValue;
        }, 0);
    },
    mileageHigh: state => {
        return state.all.reduce((highValue, car) => {
            // normalize the mileage to check
            let miles = car.mileage && car.mileage > 0 ? car.mileage : 0;
            // check if current value is higher
            if (miles > highValue) highValue = miles;
            return highValue;
        }, 0);
    },
    allFilterOptions: (state, getters) => {
        const categories = {};
        if (getters.type.length) categories.type = getters.type;
        if (getters.year.length) categories.year = getters.year;
        if (getters.make.length) categories.make = getters.make;
        if (getters.model.length) categories.model = getters.model;
        if (getters.trim.length) categories.trim = getters.trim;
        if (getters.body.length) categories.body = getters.body;
        if (getters.drive.length) categories.drive = getters.drive;
        if (getters.transmission.length)
            categories.transmission = getters.transmission;
        if (getters.colorExt.length) categories.colorExt = getters.colorExt;
        if (getters.engine.length) categories.engine = getters.engine;
        categories.price = [0, getters.priceHigh];
        categories.mileage = [0, getters.mileageHigh];
        return categories;
    },
};

export const mutations = {
    SET_VEHICLES(state, vehicles) {
        state.all = [...vehicles];
    },
};

export const actions = {
    async GET_ALL_VEHICLES({ commit, rootGetters }) {
        try {
            const employeeArkona = rootGetters['user/employeeArkona'];
            const arkona = employeeArkona || 'cag';
            const promises = [
                api.vehicles.getAllByType({ arkona, type: 'new' }),
                api.vehicles.getAllByType({ arkona, type: 'used' }),
            ];
            const [newResult, usedResult] = await Promise.all(promises);
            if (newResult.status === 200 && usedResult.status === 200) {
                commit('SET_VEHICLES', [...newResult.data, ...usedResult.data]);
            }
        } catch (err) {
            // eslint-disable-next-line
            console.error(Error(err));
        }
    },
};
